import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SchedulingHeader from "./SchedulingHeader";
import SchedulingTable from "./SchedulingTable";
import { loadPage } from "../../scheduling/schedulingSlice";
import { convertSchedulingEventsToCalender } from "../../../components/util/helpers";

const Scheduling = () => {
  const [currentDate, setCurrentDate] = useState(moment());
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [events, setEvents] = useState([]);
  const { page: schedulingPage } = useSelector((state) => state.scheduling);
  const { items, effective_orders, order_time_extractions } = schedulingPage;
  const loadLoading = useSelector(
    (state) => state.pendingActions["scheduling/load"]
  );
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (currentDate && activePatient.id) {
      dispatch(
        loadPage({
          query: {
            from: currentDate.startOf("month").format(),
            to: currentDate.endOf("month").format(),
          },
        })
      );
    }
  }, [dispatch, currentDate, activePatient.id]);

  useEffect(() => {
    const convertedToCalender = convertSchedulingEventsToCalender(items);
    setEvents(convertedToCalender);
    setFilteredOrders([]);
  }, [items]);

  const onNextDate = () => {
    setCurrentDate(moment(currentDate).add(1, "months"));
  };
  const onPreviousDate = () => {
    setCurrentDate(moment(currentDate).subtract(1, "months"));
  };

  const onFilterOrdersChanged = (eventId, val) => {
    const newFiltered = val
      ? filteredOrders.filter((item) => item !== eventId)
      : [...filteredOrders, eventId];
    setFilteredOrders(newFiltered);
  };

  return (
    <div>
      <SchedulingHeader
        currentDate={currentDate}
        effective_orders={effective_orders}
        order_time_extractions={order_time_extractions}
        onFilterOrdersChanged={onFilterOrdersChanged}
        onNextDate={onNextDate}
        onPreviousDate={onPreviousDate}
        filteredOrders={filteredOrders}
      />
      <SchedulingTable
        filteredOrders={filteredOrders}
        events={events}
        loadLoading={loadLoading}
      />
    </div>
  );
};

export default Scheduling;
